import React from 'react';

const SU2SU = 'https://www.startup2standup.com';

const TESTIMONIALS = [
    { img: 'avatar-mark-bernstein.png', alt: 'Mark Bernstein', quote: "I've seen at first hand how this community delivers mutual support and cross fertilisation. It works.", name: 'Mark Bernstein', role: 'CEO, Diligentsia' },
    { img: 'avatar-ollie-austen.png', alt: 'Ollie Austen', quote: 'It gives me great pleasure to see not only the mutual support founders provide each other, but the concrete value we deliver through introductions. Over 80% of our members have established business relationships with at least three other members.', name: 'Ollie Austen', role: 'Founder, SU2SU' },
    { img: 'avatar-chris-enoh.png', alt: 'Chris Enoh, Co-Founder, Enbros', quote: 'Ollie and his team have made introductions that transformed my business. I simply could not have reached those opportunities without the supportive help of SU2SU.', name: 'Co-Founder', role: 'Enbros' },
];

// require() must take a literal, so the avatars are resolved through a static map.
const AVATARS = {
    'avatar-mark-bernstein.png': require('../../../../images/landing-pages/community/avatar-mark-bernstein.png'),
    'avatar-ollie-austen.png': require('../../../../images/landing-pages/community/avatar-ollie-austen.png'),
    'avatar-chris-enoh.png': require('../../../../images/landing-pages/community/avatar-chris-enoh.png'),
};

const CommunityPeopleSection = () => (
    <section className="lp-cm-people">
        <div className="lp-cm-people-inner">
            <div>
                <span className="lp-cm-eyebrow lp-cm-eyebrow--dark" data-lp-reveal><span className="dot" />Our active community</span>
                <h2 className="lp-cm-h2 lp-cm-h2--dark" data-lp-reveal data-lp-delay="60">Business is still about people.</h2>
                <p className="lp-cm-lead lp-cm-lead--dark" data-lp-reveal data-lp-delay="120">That's why we're active partner of Startup 2 Standup, one of the UK's leading founder communities — because a platform is only as strong as the relationships behind it.</p>

                <div className="lp-cm-su2su" aria-label="Startup 2 Standup community" data-lp-reveal data-lp-delay="180">
                    <img src={require('../../../../images/landing-pages/community/su2su-card.webp')} alt="Startup 2 Standup community" />
                </div>

                <a className="lp-cm-su2su-btn" href={SU2SU} target="_blank" rel="noopener noreferrer" data-lp-reveal data-lp-delay="220">Find out more</a>
            </div>

            <div className="lp-cm-testi-list">
                {TESTIMONIALS.map((t, i) => (
                    <div className="lp-cm-testi" key={t.name + i} data-lp-reveal data-lp-delay={i * 90}>
                        <img src={AVATARS[t.img]} alt={t.alt} />
                        <div>
                            <div className="lp-cm-testi-mark">“</div>
                            <p>{t.quote}</p>
                            <div className="lp-cm-testi-name">{t.name}</div>
                            <div className="lp-cm-testi-role">{t.role}</div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    </section>
);

export default CommunityPeopleSection;
